import { FieldValueLookupError } from '../../../common/errors';
import type {
	RadioButtonsPublicGetValue,
	RadioButtonsPublicSetValue,
} from '../../../common/fields/radio-buttons';
import type { OptionsVisibility } from '../../../common/types/options-visibility';
import { applyOptionsVisibilityRule } from '../../../common/utils/apply-options-visibility-rule';
import { getAvailableOptionsVisibilityRule } from '../../../common/utils/get-available-options-visibility-rule';
import { singleValueLookup } from '../../../common/utils/single-value-lookup';

export type RadioButtonsInternalAllowedValue = {
	id: string;
	value: string;
};

export type RadioButtonsInternalValue = {
	label: string;
	value: string;
} | null;

export const transformRadioButtonsSetOptionsVisibility = (
	optionsVisibility: OptionsVisibility,
	lookupValues: RadioButtonsInternalAllowedValue[],
): RadioButtonsInternalAllowedValue[] =>
	applyOptionsVisibilityRule(optionsVisibility, lookupValues, 'id');

export const transformRadioButtonsGetOptionsVisibility = (
	optionsVisibility: OptionsVisibility,
	lookupValues: RadioButtonsInternalAllowedValue[],
): OptionsVisibility => getAvailableOptionsVisibilityRule(optionsVisibility, lookupValues, 'id');

export const radioButtonsSetValueTransformer = (
	value: RadioButtonsPublicSetValue,
	allowedValues?: RadioButtonsInternalAllowedValue[],
): RadioButtonsInternalValue => {
	if (value === null) {
		return null;
	}

	const foundValue = singleValueLookup<RadioButtonsInternalAllowedValue>(
		value,
		allowedValues,
		'id',
	);

	if (!foundValue) {
		throw new FieldValueLookupError();
	}

	return { value: foundValue.id, label: foundValue.value };
};

export const radioButtonsGetValueTransformer = (
	value: RadioButtonsInternalValue,
): RadioButtonsPublicGetValue => {
	if (!value) {
		return null;
	}

	const { label, value: id } = value;

	return { id, value: label };
};
